var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticStyle:{"font-size":"1em"}},[_c('img',{style:({ width: _vm.width }),attrs:{"src":_vm.ASSETS_BASE_URL + 'logo.png'}})])}
var staticRenderFns = []

export { render, staticRenderFns }